<div *ngIf="!!profile; else loading;">
  <div class="picture"><img src="{{profile.social.picture}}"></div>
  <div id="profile-detail-component">
    <div class="bigfield"><span class="h2">{{profile.social.name}}</span></div>
    <div class="field"><label>email: </label>{{profile.social.email}}</div>
    <div class="toggleField" (click)="toggleReview(0)"><label>Global reviewer:</label>
      <div *ngIf="profile.review; else noreview" class="tfimage"><img src="/images/confirm.svg"></div>
      <ng-template #noreview>
        <div class="tfimage"><img src="/images/cancel.svg"></div>
      </ng-template>
    </div>
    <div class="toggleField" (click)="toggleAdminister(0)"><label>Global administer: </label>
      <div *ngIf="profile.administer; else noadmin" class="tfimage"><img src="/images/confirm.svg"></div>
      <ng-template #noadmin>
        <div class="tfimage"><img src="/images/cancel.svg"></div>
      </ng-template>
    </div>
    <ng-container *ngFor="let programme of programmes">
      <div class="toggleField" *ngIf="CanAdministerProgramme(programme.id)">
        <label>Station {{programme.name}}: </label>
        <span (click)="toggleReview(programme.id)"> Review
          <img class="tfimage" src="{{ImageSource('review', programme.id)}}">
        </span>
        <span (click)="toggleAdminister(programme.id)"> Admin
          <img class="tfimage" src="{{ImageSource('admin', programme.id)}}">
        </span>
      </div>
    </ng-container>
  </div>
</div>
<ng-template #loading>
  Loading...
</ng-template>